import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { courierKeys } from '@dukanti/shared';
import { getAdminCourierProof } from '@dukanti/shared/services';
import type { AdminCourierProof } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useAdminCourierProof(
  storeId: string | null,
  proofId: string | null,
): UseQueryResult<AdminCourierProof> {
  return useQuery<AdminCourierProof>({
    queryKey: courierKeys.proof(storeId, proofId),
    enabled: !!storeId && !!proofId,
    staleTime: 60_000,
    gcTime: 120_000,
    queryFn: () => getAdminCourierProof(supabase, storeId as string, proofId as string),
  });
}
